// HM-376 cluster 16.4: buildingLabelOf con override DB-driven.
// Risolve tech debt cluster 15.4 ("BUILDING_LABEL hardcoded → da DB
// cluster 16"). API: chiamatore puo' passare `override` (mappa
// code -> label letta da useBuildingsList) per usare i label reali
// del DB. Senza override (legacy callers), fallback hardcode.

const BUILDING_LABELS_FALLBACK: Record<string, string> = {
  main: 'Edificio principale',
  annex: 'Corpo distaccato',
  detached: 'Corpo distaccato',
};

export function buildingLabelOf(code: string, override?: Record<string, string>): string {
  if (override?.[code]) return override[code];
  return BUILDING_LABELS_FALLBACK[code] ?? `Edificio ${code}`;
}

/**
 * Helper hook-like: trasforma una lista Building in mappa code->label.
 * Da usare lato componente con useQuery(['buildings']).
 */
export function buildLabelMap(
  buildings: Array<{ code: string; label: string }> | undefined,
): Record<string, string> {
  if (!buildings) return {};
  return Object.fromEntries(buildings.map((b) => [b.code, b.label]));
}
